// Live's words for a cost tier of 1 to 5 bolts (`PriceTierBadge`'s `TIER_HINTS`): one word a tier,
// shared by the Studio's model lists and the templates, so a tier reads the same everywhere.
const WORDS = ["Lowest", "Low", "Moderate", "High", "Highest"] as const;

/** The tier's word, the tier held to 1 to 5. */
export function tierWord(tier: number): string {
  return WORDS[Math.min(Math.max(Math.round(tier), 1), WORDS.length) - 1]!;
}
